import React from 'react';
import PropTypes from 'prop-types';

import withModifier from '../../twig-extensions/filter/withModifier';

import Icon from '../icon/Icon.jsx';
import Spinner from '../spinner/Spinner.jsx';
import Text from '../text/Text.jsx';

const Button = ({
  label,
  type,
  disabled,
  variant,
  labelVariant,
  className,
  modifiers,
  onClick,
  hiddenLabel,
  icon,
  iconSize,
  isLoading
}) => (
  <button
    className={`button ${className} ${withModifier(
      'button',
      variant ? [...modifiers, variant] : modifiers
    )}`}
    // eslint-disable-next-line react/button-has-type
    type={type}
    disabled={disabled}
    aria-disabled={disabled}
    title={label}
    aria-label={label}
    onClick={onClick}
  >
    {icon && !isLoading && (
      <Icon id={icon} size={iconSize} className="button__icon" />
    )}
    {isLoading && <Spinner />}
    {hiddenLabel ? null : (
      <Text variant={labelVariant} tag="span">
        {label}
      </Text>
    )}
  </button>
);

Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  labelVariant: PropTypes.string,
  className: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  hiddenLabel: PropTypes.bool,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  isLoading: PropTypes.bool
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  variant: undefined,
  labelVariant: 'button',
  className: '',
  modifiers: [],
  onClick: null,
  hiddenLabel: false,
  icon: null,
  iconSize: 'small',
  isLoading: false
};

export default Button;
